import {
	Button,
	Card,
	Input,
	makeStyles,
	Typography
} from '@material-ui/core';
import React from 'react';
import * as dayjs from 'dayjs';
import { useActions, useValues } from 'kea';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SendIcon from '@material-ui/icons/Send';

import { rerentlogic } from 'src/store/report';
import prettytime from '../../../utils/prettytime';

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const ErentReport = () => {
	const classes = useStyles();
	const { report } = useValues(rerentlogic);
	const { fetch } = useActions(rerentlogic);
	const [file, setFile] = React.useState(null);

	const handleFileUpload = (event) => {
		console.log(event.target.files)
		event.preventDefault();
		setFile(event.target.files[0]);
	}

	const handleSubmit = () => {
		if (!file) {
			alert('Please select a file');
			return;
		}
		fetch(file);
	}

	return (
		<>
			<Card
				className={classes.root}
			>
				<div style={{ height: "100%", width: "100%", background: "white", padding: "20px" }}>
					<Typography variant="h4">
						E-Rent Last Connected Report
					</Typography>
					<div style={{ gap: "10px" }}>
						<div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>

							<Button
								component="label"
								role={undefined}
								variant="contained"
								tabIndex={-1}
								startIcon={<CloudUploadIcon />}
								style={{
									marginTop: "10px",
									marginBottom: "10px",
								}}
							>
								Select files
								<Input
									style={{
										clip: "rect(0 0 0 0)",
										clipPath: "inset(50%)",
										height: 1,
										overflow: "hidden",
										position: "absolute",
										bottom: 0,
										left: 0,
										whiteSpace: "nowrap",
										width: 1,
									}}
									type="file"
									onChange={handleFileUpload}
								/>
							</Button>
							<Typography variant="subtitle1">
								{file?.name}
							</Typography>
						</div>
						<Button
							variant="contained"
							endIcon={<SendIcon />}
							disabled={!file}
							size='medium'
							onClick={handleSubmit}
						>
							Submit
						</Button>
					</div>
				</div>
			</Card>
		</>
	);
};


export default ErentReport;